import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/BasketItemPerson`;

const headers = {
  'Content-Type': 'multipart/form-data',
};

const ApiBasketItemPerson = {
  getAllTicket: () => {
    const url = `${baseServiceUrl}/getAllTicket`;
    return ServiceApi.get(url);
  },
  getAllLastTicket: () => {
    const url = `${baseServiceUrl}/getAllLastTicket`;
    return ServiceApi.get(url);
  },
  getTicketById: (ticketNumber) => {
    const url = `${baseServiceUrl}/getTicketById`;
    return ServiceApi.get(url, {
      params: {
        ticketNumber: ticketNumber,
      },
    });
  },
  cancelTickets: (params) => {//ابطال بلیط
    const url = `${baseServiceUrl}/useTickets`;
    return ServiceApi.post(url, params);
  },
  getUsedTicketsByIds: (params) => {
    const url = `${baseServiceUrl}/getUsedTicketsByIds`;
    return ServiceApi.post(url, params);
  },
  getBasketItemPersonsReport: (params) => {
    const url = `${baseServiceUrl}/basketItemPersonsReport`;
    return ServiceApi.get(url, { params });
  },
};

export default ApiBasketItemPerson;


